module.exports = {"520622001":"皂角坪街道","520622002":"平溪街道","520622003":"大龙街道","520622004":"麻音塘街道","520622100":"新店镇","520622102":"朱家场镇","520622103":"田坪镇","520622200":"亚鱼乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520622.json
// module id = 2628
// module chunks = 0